import React from 'react';
import { Stack } from '@hub/stack';
import { Grid } from '@hub/grid';
import { StoreGridItem } from './store-grid-item';
import { jsx as _jsx } from "react/jsx-runtime";
export const GridView = _ref => {
  let {
    centre,
    stores,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx(Stack, {
    "data-id": "visible-stores_grid-view_GridView_Stack",
    children: /*#__PURE__*/_jsx(Grid, {
      maxWidth: ['size-md', null, 'size-sm'],
      sx: {
        gridGap: ['spacing-md']
      },
      role: "list",
      templateColumns: ['repeat(2, 1fr)', 'repeat(3, 1fr)', 'repeat(5, 1fr)'],
      "data-id": "visible-stores_grid-view_GridView_Stack_Grid",
      children: stores.map(store => /*#__PURE__*/_jsx(StoreGridItem, {
        centre: centre,
        store: store,
        onClick: e => onClick(e, store),
        "data-id": "visible-stores_grid-view_GridView_StoreGridItem"
      }, store.id))
    })
  });
};